module.exports = __webpack_public_path__ + "static/media/bitcoin-sign.f1b14481.gif";